module.exports = __webpack_public_path__ + "static/media/EmailOutline.4f4cbc64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/EmailOutline.svg
// module id = 385
// module chunks = 0